import React from 'react';
import { Field, Section, patchSection } from './shared';

const HEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

const ColorField = ({ label, value, fallback, onChange }) => (
  <Field label={label}>
    <div className="flex gap-2">
      <input
        type="color" aria-label={label} className="h-10 w-12 rounded border border-slate-200 bg-white p-1"
        value={HEX.test(value || '') && value.length === 7 ? value : fallback}
        onChange={(e) => onChange(e.target.value)}
      />
      <input className="input" value={value || ''} placeholder={fallback} maxLength={7} onChange={(e) => onChange(e.target.value)} />
    </div>
    {value && !HEX.test(value) && <p className="text-xs text-red-600 mt-1">Use um hexadecimal válido (ex: #1F6FEB)</p>}
  </Field>
);

export const isSafeLogoUrl = (v) => {
  if (!v) return true;
  if (/[\s"'<>\x00-\x1f]/.test(v)) return false;
  try { return new URL(v).protocol === 'https:'; } catch { return false; }
};

export default function DesignTab({ schema, onChange }) {
  const theme = schema.theme || {};
  const set = (patch) => onChange(patchSection(schema, 'theme', patch));
  const logoOk = isSafeLogoUrl(theme.logoUrl);

  return (
    <Section title="Aparência">
      <div className="grid sm:grid-cols-2 gap-4">
        <ColorField label="Cor principal" value={theme.primaryColor} fallback="#1F6FEB" onChange={(v) => set({ primaryColor: v })} />
        <ColorField label="Cor de fundo" value={theme.backgroundColor} fallback="#F5F7FA" onChange={(v) => set({ backgroundColor: v })} />
      </div>
      <Field label="URL do logo (HTTPS)" hint="O logo precisa estar hospedado em uma URL pública HTTPS. Não há upload de arquivos.">
        <input className="input" type="url" placeholder="https://exemplo.com/logo.png" value={theme.logoUrl || ''}
          onChange={(e) => set({ logoUrl: e.target.value })} />
        {!logoOk && <p className="text-xs text-red-600 mt-1">A URL deve começar com https:// e não conter espaços ou aspas.</p>}
      </Field>
      <Field label="Formato do logo">
        <select className="input" value={theme.logoShape || 'circle'} onChange={(e) => set({ logoShape: e.target.value })}>
          <option value="circle">Redondo</option>
          <option value="square">Quadrado</option>
        </select>
      </Field>
      <Field label="Texto de rodapé">
        <input className="input" maxLength={300} value={theme.footerText || ''} placeholder="Seus dados são tratados conforme a LGPD."
          onChange={(e) => set({ footerText: e.target.value })} />
      </Field>
    </Section>
  );
}
